/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IMediaGalleryThumbnailItemViewProps, IMediaGalleryViewProps } from '@msdyn365-commerce-modules/media-gallery';

import { IMediaGalleryThumbnailsViewProps } from './product-media-gallery';

const MediaGalleryView: React.FC<IMediaGalleryViewProps> = props => {
    const { CarouselProps, Thumbnails, MediaGallery, Modal } = props;

    return (
        <Module {...MediaGallery}>
            <Node {...CarouselProps} />
            {Modal}
            {_renderThumbnails(Thumbnails)}
        </Module>
    );
};

const _renderThumbnails = (thumbnails: IMediaGalleryThumbnailsViewProps): JSX.Element => {
    const { ThumbnailsContainerProps, SingleSlideCarouselComponentProps, items, videos } = thumbnails;

    let thumbnailItems = items ?? [];
    if (videos) {
        thumbnailItems = [...thumbnailItems, ...videos];
    }

    return (
        <Node {...ThumbnailsContainerProps}>
            <Node {...SingleSlideCarouselComponentProps}>{thumbnailItems.map(_renderThumbnailItem)}</Node>
        </Node>
    );
};

const _renderThumbnailItem = (thumbnail: IMediaGalleryThumbnailItemViewProps): JSX.Element => {
    const { ThumbnailItemContainerProps, Picture } = thumbnail;

    return <Node {...ThumbnailItemContainerProps}>{Picture}</Node>;
};

export default MediaGalleryView;
